import script from "./TheoDoiHopDongTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./TheoDoiHopDongTable.vue?vue&type=script&lang=ts&setup=true"

import "./TheoDoiHopDongTable.vue?vue&type=style&index=0&id=68f570da&lang=scss&scoped=true"

import exportComponent from "/var/www/prod/fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68f570da"]])

export default __exports__